import { reportRtcCall } from './src/utils/reporter.js';

// WebRTC call detection
try {
  const OriginalRTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;

  if (OriginalRTCPeerConnection) {
    const RTCPeerConnectionProxy = new Proxy(OriginalRTCPeerConnection, {
      construct: function(target, args) {
        try {
          // Always capture the stack trace for every call
          const stack = new Error('WebRTC Call Stack').stack || '';
          
          console.log('WebRTC call detected. Reporting with stack trace...');
          console.log(stack); // For real-time debugging in the browser

          // Prepare data for reporting, always including the stack trace
          const rtcData = {
              type: 'webrtc_call',
              config: args[0] || {}, // The first argument is the configuration
              timestamp: Date.now(),
              stack: stack, // Include the captured stack trace
          };
  
          // Report the data for every call
          reportRtcCall(rtcData);

        } catch (e) {
          // In case stack trace generation fails
          console.error('Error capturing or reporting WebRTC stack trace:', e);
        }
        
        // This ensures the original functionality is not broken
        return Reflect.construct(target, args);
      }
    });

    // Replace the original constructor with the proxy
    if (window.RTCPeerConnection) {
      window.RTCPeerConnection = RTCPeerConnectionProxy;
    } else if (window.webkitRTCPeerConnection) {
      window.webkitRTCPeerConnection = RTCPeerConnectionProxy;
    } else if (window.mozRTCPeerConnection) {
      window.mozRTCPeerConnection = RTCPeerConnectionProxy;
    }
  }
} catch (e) {
  console.error('Error setting up WebRTC tracking:', e);
}

import createApp from './src/app.js'

const { app, router, store } = createApp()

// // 检查是否存在服务器端注入的状态
if (window.__INITIAL_STATE__) {
	store.replaceState(window.__INITIAL_STATE__)
}

router.onReady(() => {
	// 挂载Vue实例时，将服务端的context注入
	app.$mount('#app')
})
